import React from 'react';
import { motion } from 'framer-motion';
export function ResultsSection() {
  return <section className="py-24 bg-brand-dark relative overflow-hidden" data-id="element-176">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,107,26,0.05),transparent_70%)]" data-id="element-177" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-178">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-br from-brand-orange/20 to-transparent border border-brand-orange/30 p-8 md:p-12 rounded-3xl text-center" data-id="element-179">
          <h2 className="text-3xl md:text-4xl uppercase mb-6" data-id="element-180">
            LO QUE CAMBIA EN <span className="text-brand-orange" data-id="element-181">7 DÍAS</span>
          </h2>

          <p className="text-xl md:text-2xl leading-relaxed text-zinc-200 font-medium" data-id="element-182">
            En una semana, la sensación de culpa por no entrenar desaparece.
            Dejas de ver tu living como un espacio de pereza y lo empiezas a ver
            como tu zona de poder. Notarás más firmeza en tus brazos y piernas,
            y la comodidad de terminar tu rutina y estar a dos pasos de tu
            propia ducha no tiene precio.
          </p>
        </motion.div>
      </div>
    </section>;
}